import HeaderOrange from "../../../../components/common/HeaderOrange/HeaderOrange";
import Tabs from "../../../../components/common/Tabs/Tabs";
import { useState } from "react";
import OrderMaterial from "./OrderMaterial/OrderMaterial";
import TrackingAndUpdates from "./TrackingAndUpdates/TrackingAndUpdates";

const PackagingMaterial = () => {
  const tabs = ["Order Material", "Tracking and Updates"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", padding: "20px 30px" }}>
      <div className="fw-semibold fs-4 mb-3">Packaging Material Order</div>

      <HeaderOrange>
        Easily manage your packaging needs with our Packaging Material Order
        page. Select from various materials, view pricing, and apply bulk
        discounts. The total cost updates automatically based on your choices,
        and you'll receive timely updates on order status and delivery. Ensure
        secure shipping with high-quality packaging materials.
      </HeaderOrange>

      <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === "Order Material" && <OrderMaterial />}
      {activeTab === "Tracking and Updates" && <TrackingAndUpdates />}
    </div>
  );
};

export default PackagingMaterial;